export interface IAdminEmailView{
  emailId: number;
  countyId: string;
  emailTypeId: number;
  emailTypeDescription: string;
  emailTo: string;
  firstName: string;
  lastName: string;
  emailCc: string;
  emailFrom: string;
  subject: string;
}

export interface ISaveAdminComplaint{
  complaintId: number;
  complaintComments: string;
  complaintStatusId: number;
  actionable: boolean;
  selectedNatureOfComplaints: string[];
  reasonNonActionableId: number;
}


export interface ISaveAdminBusiness{
  businessId: number;
  businessName: string;
  businessType: number;
  active: boolean;
  exempt: boolean;
  businessAddress1: string;
  businessAddress2: string;
  businessCity: string;
  businessZip: string;
  businessZipExt: string;
  countyId: string;
  exemptCertificateDate: string;
  exemptStatusId: string;
  exemptTypeId: string;
  exemptSmokingAllowed: boolean;
  exemptApprovedBy: string;
  exemptEnteredBy: string;
}

export interface IRoleEdit{
  name: string;
  id: string;
}

export interface IApplicationUser{
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  fipsCountyId: string;
  enabled: boolean;
}

export interface IUserAndRoles{
  user: IApplicationUser;
  roles: string[];
}

export interface ISaveUserAndRoles{
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  fipsCountyId: string;
  enabled: boolean;
  roles: string[];
}

export interface IUserAndRolesList{
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  fipsCountyId: string;
  enabled: boolean;
  userAndRole: IUserAndRoles;
}